import { g as getColour } from '../../dist/getColour-aed6eedd.esm.js';
import { getThemeName } from '../../utils/dist/commons.esm.js';
import 'styled-components';
import 'react';
var getFocusRing = opts => {
  var ringColour = getColour('border', 'interaction', {
    state: 'focus'
  });
  if (opts !== null && opts !== void 0 && opts.background) {
    return "0 0 0 2px ".concat(opts.background, ", 0 0 0 2px ").concat(ringColour);
  }
  return "0 0 0 2px ".concat(getColour('fill', 'main'), ", 0 0 0 4px ").concat(ringColour);
};
var getFocusOutline = () => "".concat(getColour('border', 'interaction', {
  state: 'focus'
}), " solid 2px");
var getFocusOutlineOffset = () => "2px";
var semantics$3 = {
  default: '6px',
  decorative: '6px',
  button: '6px',
  checkbox: '3px'
};
var semantics$2 = {
  default: '6px',
  decorative: '6px',
  button: '50px',
  checkbox: '3px'
};
var semantics$1 = {
  default: '0',
  decorative: '16px',
  button: '50px',
  checkbox: '3px'
};
var semantics = {
  default: '2px',
  decorative: '2px',
  button: '3px',
  checkbox: '3px'
};
var getRadius = (category, themeName) => {
  var internalTheme = themeName !== null && themeName !== void 0 ? themeName : getThemeName();
  var brandMap = {
    lendi: semantics$3,
    'lendi-next': semantics$2,
    aussie: semantics$1,
    domain: semantics
  };
  return brandMap[internalTheme][category !== null && category !== void 0 ? category : 'default'];
};

// Temporary Backwards compatibility adapter
// TODO: remove when all components are migrated
var getBorderRadius = opts => {
  return getRadius('default', opts.theme);
};
export { getBorderRadius, getFocusOutline, getFocusOutlineOffset, getFocusRing, getRadius };